// Centralized AR/EN copy for the landing page (pages/landing).
// Text is preserved verbatim from the LUD_HOME_WITH_SOLUTIONS_V5 reference design.

export const landingContent = {
  ar: {
    nav: {
      home: "الرئيسية",
      whoWeAre: "من نحن",
      aboutPlatform: "عن المنصة",
      solutions: "حلول LUD",
      plans: "الباقات",
      contact: "تواصل معنا",
      login: "تسجيل الدخول",
      start: "ابدأ الآن",
      dashboard: "لوحة التحكم",
      openMenu: "فتح القائمة",
      displaySettings: "إعدادات العرض",
      switchTheme: "تبديل المظهر",
      changeLanguage: "تغيير اللغة",
    },
    hero: {
      title: "تابع مطعمك على تطبيقات التوصيل",
      subtitle: "اتخذ قرارات لنمو مستدام",
      start: "ابدأ الآن",
      login: "تسجيل الدخول",
      balls: [
        "7 تطبيقات توصيل",
        "المبيعات",
        "الاعتراضات",
        "التعويضات",
        "الحملات",
        "العمليات",
        "قائمة الطعام",
        "الفروع",
        "توثيق الطلبات",
        "المدفوعات",
        "مبيعات الأصناف",
        "البيانات والمستندات",
        "تحليل الأداء",
        "التنبيهات",
        "الدعم الفني",
        "الدمج",
        "المطابقة المالية",
        "تحسين الصور",
      ],
    },
    solutions: {
      kicker: "حلول LUD",
      title: "حلول LUD",
      description:
        "حلول متكاملة لإدارة ومتابعة أعمال المطعم عبر تطبيقات التوصيل من مكان واحد.",
      items: [
        {
          num: "01",
          title: "هندسة قائمة الطعام (محرك المبيعات)",
          text: "تمكّن المطعم من إدارة قائمة الطعام ومتابعتها وتطويرها وتحديثها، إلى جانب إنشاء الخصومات، وجدولة الأصناف والعروض، بما يدعم تطوير القائمة واستمرارية تحسينها.",
        },
        {
          num: "02",
          title: "الحسابات المالية",
          text: "تتيح للمطعم متابعة التفاصيل المالية، بما يشمل المدفوعات والخصومات ومؤشرات الربح والخسارة، بما يساعد على قراءة الأداء المالي بصورة أكثر وضوحًا.",
        },
        {
          num: "03",
          title: "التقارير",
          text: "تمكّن المطعم من متابعة عدد الطلبات وقيمتها وحالاتها عبر تطبيقات التوصيل والفروع المختلفة من مكان واحد.",
        },
        {
          num: "04",
          title: "الاعتراضات والتعويضات",
          text: "تساعد المطعم على متابعة توثيق الطلبات من خلال الفروع، وإرفاق الصور والمعلومات المرتبطة بها، بما يدعم الاعتراضات المتعلقة بالتعويضات والأخطاء ويسهم في تقليل الأخطاء التشغيلية.",
        },
        {
          num: "05",
          title: "التسويق",
          text: "تمكّن المطعم من الاطلاع على العروض والحملات المتاحة عبر تطبيقات التوصيل، وبناء الخطط التسويقية، ومتابعة تكلفة الحملات والعائد الناتج عنها.",
        },
        {
          num: "06",
          title: "الحوكمة والبيانات",
          text: "تتيح للمطعم إدارة بياناته ومستنداته المرتبطة بتطبيقات التوصيل من مكان واحد، بما يساعد على تنظيم البيانات، والحد من تشتتها، وتسهيل الوصول إليها وتحديثها.",
        },
        {
          num: "07",
          title: "الدعم",
          text: "توفر نقطة دعم موحدة للطلبات والاستفسارات المتعلقة بتطبيقات التوصيل، بما يسهّل متابعتها والتعامل معها من مكان واحد.",
        },
        {
          num: "08",
          title: "التشغيل وربط الفروع",
          text: "تربط الفروع بالإدارة وتدعم المتابعة التشغيلية اليومية، بما يشمل تحديثات قائمة الطعام، وتشغيل التطبيقات وإيقافها، وتوثيق الطلبات، ومتابعة الأخطاء، والحصول على الدعم والإرشادات اللازمة.",
        },
        {
          num: "09",
          title: "العمليات والتحليلات",
          text: "تتيح للمطعم متابعة وضعه الحالي عبر تطبيقات التوصيل، ومراقبة الحملات الفعالة ومستوى الأداء، والاستفادة من التحليلات والرسومات البيانية في قراءة النتائج ودعم اتخاذ القرار.",
        },
        {
          num: "10",
          title: "التنبيهات",
          text: "تساعد على متابعة التحديثات والطلبات والإجراءات المطلوبة في الوقت المناسب، وفقًا للحالة والجهة المعنية.",
        },
      ],
    },
    onboarding: {
      stepsTitle: "كيف تبدأ؟",
      stepsSubtitle:
        "تمر عملية التهيئة بخمس خطوات رئيسية قبل فتح لوحة التحكم وإتاحة خدمات المنصة.",
      steps: [
        {
          num: "01",
          title: "تعبئة البيانات الأولية",
          text: "أدخل اسم المسؤول، البريد الإلكتروني، المدينة، رقم الهاتف، اسم المطعم وعدد الفروع، ثم أرسل الطلب.",
        },
        {
          num: "02",
          title: "إنشاء الحساب وتسجيل الدخول",
          text: "يتم إنشاء حسابك تلقائيًا، وتُرسل بيانات الدخول إلى بريدك الإلكتروني المسجل. بعد ذلك، سجّل الدخول لاستكمال بيانات المنشأة والمستندات المطلوبة.",
        },
        {
          num: "03",
          title: "استكمال البيانات النظامية",
          text: "استكمل بيانات السجل التجاري، والرقم الضريبي إن وجد، وبيانات المالك والمسؤول المباشر، والمعلومات المطلوبة لإصدار الفاتورة.",
        },
        {
          num: "04",
          title: "الفاتورة واعتماد الدفع",
          text: "تُصدر فاتورة رسوم التسجيل والتفعيل، ثم يتم السداد عبر التحويل البنكي ورفع إيصال التحويل لمراجعته واعتماده من القسم المالي.",
        },
        {
          num: "05",
          title: "فتح لوحة التحكم",
          text: "بعد اعتماد الدفعة، تُفتح لوحة التحكم وتصبح خدمات التهيئة والمتابعة متاحة داخل المنصة.",
        },
      ],
      servicesTitle: "بعد فتح لوحة التحكم",
      servicesSubtitle:
        "تظهر الخدمات بشكل مستقل داخل لوحة التحكم، ويمكن بدء أكثر من خدمة ومتابعة حالتها ومتطلباتها دون ترتيب إلزامي بينها.",
      services: [
        {
          num: "01",
          title: "هندسة قائمة الطعام",
          text: "تعبئة البيانات والمرفقات المطلوبة لإنشاء قائمة الطعام، ثم إرسال الطلب. يتم إعداد القائمة وإرسالها للمراجعة خلال مدة أقصاها 7 أيام عمل بعد اكتمال المتطلبات، ثم يعتمد العميل النسخة النهائية.",
        },
        {
          num: "02",
          title: "التقارير والتحليلات",
          text: "للحصول على التقرير التحليلي، تُعبأ البيانات المطلوبة ويُحدد نطاق التحليل ثم يُرسل الطلب. يتم إعداد التقرير وإرساله خلال مدة أقصاها 7 أيام عمل بعد اكتمال المتطلبات، ثم يُرسل للمراجعة والاعتماد.",
        },
        {
          num: "03",
          title: "إضافة حسابات التطبيقات الحالية",
          text: "إضافة بيانات حسابات تطبيقات التوصيل الحالية، والتحقق منها، وإسناد كل حساب إلى الفروع التابعة له داخل LUD.",
        },
        {
          num: "04",
          title: "التسجيل في تطبيق جديد",
          text: "تعبئة البيانات المطلوبة وإرسال طلب التسجيل، ثم استلام العقد وتوقيعه عند توفره. تتم معالجة طلب التسجيل من جانب LUD خلال مدة أقصاها 7 أيام عمل بعد اكتمال المتطلبات، ولا تشمل هذه المدة وقت معالجة أو اعتماد تطبيق التوصيل.",
        },
        {
          num: "05",
          title: "باقات LUD",
          text: "بعد إتمام التسجيل وتفعيل الحساب، يمكنك اختيار الباقة المناسبة وفق احتياج المطعم وعدد الفروع للاستمرار في استخدام المنصة.",
        },
        {
          num: "06",
          title: "خدمة الربط",
          text: "تعبئة البيانات المطلوبة وتحديد الفروع والتطبيقات المطلوب ربطها، ثم سداد الرسوم. يبدأ التنفيذ بعد اكتمال المتطلبات، وتُنجز إجراءات الربط خلال مدة تصل إلى 7 أيام عمل بحسب جاهزية الفرع والتطبيق.",
          tag: "اختيارية",
        },
      ],
      conditionsTitle: "شروط وملاحظات مهمة",
      conditionsSubtitle:
        "معلومات مهمة يجب الاطلاع عليها قبل مراجعة واعتماد مخرجات التهيئة.",
      conditions: [
        {
          summary: "اعتماد قائمة الطعام",
          items: [
            "تبدأ مهلة مراجعة قائمة الطعام من وقت إرسالها للعميل للاعتماد.",
            "مهلة المراجعة 7 أيام من وقت إرسال القائمة، وفي حال عدم الرد يتم الاعتماد تلقائيًا.",
            "يصل تذكير بعد 3 أيام، وتذكير أخير في اليوم السادس.",
            "يسمح بحد أقصى رفضين، مع إلزامية توضيح سبب الرفض.",
            "بعد الرفض الثاني وتنفيذ الملاحظات المطلوبة، يتم اعتماد النسخة المعدلة تلقائيًا.",
          ],
        },
        {
          summary: "مراجعة التقرير التحليلي",
          items: [
            "تبدأ مهلة المراجعة عند إرسال التقرير للعميل.",
            "مهلة المراجعة 7 أيام من وقت إرسال التقرير، وفي حال عدم الرد يتم اعتماد التقرير تلقائيًا.",
            "يصل تذكير بعد 3 أيام، وتذكير أخير في اليوم السادس.",
            "يسمح برفض واحد فقط مع توضيح سبب الرفض.",
            "بعد تنفيذ الملاحظة المطلوبة، يُعتمد التقرير المعدل تلقائيًا.",
          ],
        },
      ],
      registration: {
        title: "رسوم التسجيل",
        description:
          "تشمل رسوم التسجيل تهيئة بيانات المطعم وتحليل وضعه، بالإضافة إلى استخدام منصة LUD لمدة شهر واحد من تاريخ تفعيل الحساب. وبعد انتهاء الشهر، يمكن اختيار الباقة المناسبة للاستمرار في استخدام المنصة.",
        features: [
          "تحليل التقارير الشهرية حتى 12 شهرًا سابقًا.",
          "تحليل التقارير اليومية حتى 5 أشهر سابقة.",
          "تحليل المبيعات والأداء المالي والتشغيلي وقياس المؤشرات.",
          "كشف الأخطاء التشغيلية وتحديد فرص النمو والتحسين.",
          "مراجعة وهيكلة قائمة الطعام بناءً على البيانات والأداء.",
          "تصميم 8 عروض وفرص بيعية تساعد على رفع متوسط قيمة السلة.",
          "مراجعة أداء المنتجات وتحديد الأعلى والأقل أداءً.",
          "تقديم استشارة لشرح النتائج والتوصيات وخطة التحسين.",
        ],
        priceLabel: "رسوم التسجيل",
        price: "500",
        currency: "ريال",
        cta: "ابدأ الآن",
      },
    },
    plans: {
      title: "باقات LUD",
      note: "يمكنك الاطلاع على الباقات الآن، ويصبح اختيار الباقة متاحًا بعد إتمام التسجيل وتفعيل الحساب.",
      subtitle: "حدد مستوى الخدمات والمتابعة الذي يناسب احتياجك.",
      currency: "ريال / شهريًا",
      items: [
        {
          code: "L",
          name: "الأساسية",
          price: "149",
          branchNote: "الفرع الإضافي: 99 ريال شهريًا",
          features: [
            "دعم تطبيقات التوصيل السبعة",
            "لوحة التحكم والعمليات",
            "إرسال طلبات الحملات ومتابعة حالتها",
            "إرسال تعديلات قائمة الطعام ومتابعة حالتها",
            "إدارة بيانات الفروع",
            "المدفوعات والتقارير الشهرية",
            "البيانات والمستندات",
            "تحليل الأداء ومبيعات الأصناف",
            "التنبيهات",
          ],
        },
        {
          code: "U",
          name: "المتقدمة",
          price: "299",
          branchNote: "الفرع الإضافي: 249 ريال شهريًا",
          featured: true,
          features: [
            "جميع مزايا الباقة الأساسية",
            "تقارير المبيعات الأسبوعية",
            "عرض ومتابعة التعويضات",
            "توثيق الطلبات بالصور",
            "تقديم الاعتراضات من خلال المنصة",
            "إدارة الاعتراضات ومتابعتها من خلال المنصة",
          ],
        },
        {
          code: "D",
          name: "الشاملة",
          price: "499",
          branchNote: "الفرع الإضافي: 399 ريال شهريًا",
          features: [
            "جميع مزايا الباقة المتقدمة",
            "رفع الاعتراضات ومتابعتها بواسطة LUD",
            "التحقق من تنفيذ طلبات الحملات",
            "التحقق من تنفيذ تعديلات قائمة الطعام",
            "الدعم الفني",
          ],
        },
      ],
    },
    footer: {
      nav: [
        { key: "solutions", label: "حلول LUD", to: "/solutions" },
        { key: "plans", label: "الباقات", to: "/pricing" },
        { key: "contact", label: "تواصل معنا", to: "/contactus" },
        { key: "blog", label: "المدونة" },
        { key: "careers", label: "انضم إلينا / الوظائف" },
      ],
      legal: [
        { key: "terms", label: "الشروط والأحكام", to: "/terms" },
        { key: "privacy", label: "سياسة الخصوصية", to: "/privacy" },
        { key: "usagePolicy", label: "سياسة الاستخدام" },
        { key: "refund", label: "الإلغاء والاسترداد", to: "/refund" },
        { key: "sla", label: "اتفاقية مستوى الخدمة" },
        { key: "feedback", label: "الشكاوى والاقتراحات", to: "/feedback" },
      ],
      copyright: "جميع الحقوق محفوظة",
    },
    whatsapp: "تواصل معنا عبر واتساب",
  },

  en: {
    nav: {
      home: "Home",
      whoWeAre: "Who we are",
      aboutPlatform: "About",
      solutions: "LUD Solutions",
      plans: "Plans",
      contact: "Contact us",
      login: "Sign in",
      start: "Get started",
      dashboard: "Dashboard",
      openMenu: "Open menu",
      displaySettings: "Display settings",
      switchTheme: "Switch theme",
      changeLanguage: "Change language",
    },
    hero: {
      title: "Manage your restaurant across delivery apps",
      subtitle: "Make decisions for sustainable growth",
      start: "Get started",
      login: "Sign in",
      balls: [
        "7 delivery apps",
        "Sales",
        "Disputes",
        "Compensation",
        "Campaigns",
        "Operations",
        "Menu",
        "Branches",
        "Order documentation",
        "Payments",
        "Item sales",
        "Data and documents",
        "Performance analytics",
        "Alerts",
        "Technical support",
        "Integrations",
        "Financial reconciliation",
        "Image enhancement",
      ],
    },
    solutions: {
      kicker: "LUD Solutions",
      title: "LUD Solutions",
      description:
        "Integrated solutions for managing and monitoring restaurant operations across delivery apps from one place.",
      items: [
        {
          num: "01",
          title: "Menu Engineering (Sales Engine)",
          text: "Enables restaurants to manage, monitor, develop, and update their menu, while creating discounts and scheduling items and offers to support continuous menu improvement.",
        },
        {
          num: "02",
          title: "Financial Accounts",
          text: "Provides visibility into financial details, including payments, discounts, and profit-and-loss indicators, helping restaurants assess financial performance more clearly.",
        },
        {
          num: "03",
          title: "Reports",
          text: "Enables restaurants to monitor order volume, value, and status across delivery apps and branches from one place.",
        },
        {
          num: "04",
          title: "Disputes & Compensation",
          text: "Supports order documentation across branches, including photos and related information, to strengthen disputes involving compensation and errors and help reduce operational mistakes.",
        },
        {
          num: "05",
          title: "Marketing",
          text: "Enables restaurants to review available offers and campaigns across delivery apps, build marketing plans, and monitor campaign costs and returns.",
        },
        {
          num: "06",
          title: "Governance & Data",
          text: "Enables restaurants to manage delivery-app data and documents from one place, helping organize information, reduce fragmentation, and simplify access and updates.",
        },
        {
          num: "07",
          title: "Support",
          text: "Provides a unified support point for requests and inquiries related to delivery apps, making follow-up and handling more efficient from one place.",
        },
        {
          num: "08",
          title: "Operations & Branch Connectivity",
          text: "Connects branches with management and supports daily operational follow-up, including menu updates, app activation and deactivation, order documentation, error tracking, support, and guidance.",
        },
        {
          num: "09",
          title: "Operations & Analytics",
          text: "Enables restaurants to monitor their current position across delivery apps, track active campaigns and performance, and use analytics and charts to interpret results and support decision-making.",
        },
        {
          num: "10",
          title: "Alerts",
          text: "Supports timely follow-up on updates, requests, and required actions based on the case and responsible party.",
        },
      ],
    },
    onboarding: {
      stepsTitle: "How do you get started?",
      stepsSubtitle:
        "The onboarding process goes through five main steps before the dashboard is opened and platform services become available.",
      steps: [
        {
          num: "01",
          title: "Submit initial information",
          text: "Enter the responsible person’s name, email, city, phone number, restaurant name, and number of branches, then submit the request.",
        },
        {
          num: "02",
          title: "Create the account and sign in",
          text: "Your account is created automatically and the sign-in details are sent to your registered email. Then sign in to complete the establishment information and required documents.",
        },
        {
          num: "03",
          title: "Complete regulatory information",
          text: "Complete the commercial registration details, VAT number if applicable, owner and direct contact details, and the information required to issue the invoice.",
        },
        {
          num: "04",
          title: "Invoice and payment approval",
          text: "An invoice for the registration and activation fee is issued. Payment is then made by bank transfer and the transfer receipt is uploaded for review and approval by the finance team.",
        },
        {
          num: "05",
          title: "Dashboard activation",
          text: "Once the payment is approved, the dashboard is activated and the onboarding and follow-up services become available within the platform.",
        },
      ],
      servicesTitle: "After the dashboard is activated",
      servicesSubtitle:
        "Services appear independently inside the dashboard. You can start more than one service and follow its status and requirements without a mandatory sequence.",
      services: [
        {
          num: "01",
          title: "Menu engineering",
          text: "Complete the required information and attachments to create the menu, then submit the request. The menu is prepared and sent for review within a maximum of 7 business days after all requirements are complete, then the client approves the final version.",
        },
        {
          num: "02",
          title: "Reports and analytics",
          text: "To receive the analytical report, complete the required information, define the analysis scope, and submit the request. The report is prepared and delivered within a maximum of 7 business days after all requirements are complete, then sent for review and approval.",
        },
        {
          num: "03",
          title: "Add existing app accounts",
          text: "Add and verify the details of existing delivery app accounts, then assign each account to its relevant branches within LUD.",
        },
        {
          num: "04",
          title: "Register on a new app",
          text: "Complete the required information and submit the registration request, then receive and sign the contract when available. LUD processes the registration request within a maximum of 7 business days after all requirements are complete. This period does not include the delivery app’s processing or approval time.",
        },
        {
          num: "05",
          title: "LUD Plans",
          text: "After completing registration and activating the account, you can choose the plan that best fits the restaurant’s needs and number of branches to continue using the platform.",
        },
        {
          num: "06",
          title: "Integration service",
          text: "Complete the required information, select the branches and apps to be integrated, then pay the applicable fee. Implementation starts once all requirements are complete, and integration procedures are completed within up to 7 business days depending on branch and app readiness.",
          tag: "Optional",
        },
      ],
      conditionsTitle: "Important terms and notes",
      conditionsSubtitle:
        "Important information to review before reviewing and approving the onboarding deliverables.",
      conditions: [
        {
          summary: "Menu approval",
          items: [
            "The menu review period starts when it is sent to the client for approval.",
            "The review period is 7 days from the time the menu is sent. If there is no response, it is approved automatically.",
            "A reminder is sent after 3 days, followed by a final reminder on day 6.",
            "A maximum of two rejections is allowed, and the reason for rejection must be provided.",
            "After the second rejection and completion of the requested revisions, the updated version is approved automatically.",
          ],
        },
        {
          summary: "Analytical report review",
          items: [
            "The review period starts when the report is sent to the client.",
            "The review period is 7 days from the time the report is sent. If there is no response, the report is approved automatically.",
            "Only one rejection is allowed, and the reason for rejection must be provided.",
            "After the requested revision is completed, the updated report is approved automatically.",
          ],
        },
      ],
      registration: {
        title: "Registration fee",
        description:
          "The registration fee includes preparing and analyzing the restaurant’s data, in addition to one month of access to the LUD platform starting from the account activation date. After the month ends, you can choose the appropriate plan to continue using the platform.",
        features: [
          "Analysis of monthly reports for up to the previous 12 months.",
          "Analysis of daily reports for up to the previous 5 months.",
          "Analysis of sales, financial and operational performance, and KPI measurement.",
          "Identifying operational issues and opportunities for growth and improvement.",
          "Reviewing and structuring the menu based on data and performance.",
          "Designing 8 offers and sales opportunities to help increase the average basket value.",
          "Reviewing product performance and identifying the highest- and lowest-performing items.",
          "Providing a consultation to explain results, recommendations, and the improvement plan.",
        ],
        priceLabel: "Registration fee",
        price: "500",
        currency: "SAR",
        cta: "Get started",
      },
    },
    plans: {
      title: "LUD Plans",
      note: "You can review the plans now. Plan selection becomes available after registration is completed and the account is activated.",
      subtitle: "Choose the level of services and follow-up that best fits your needs.",
      currency: "SAR / month",
      items: [
        {
          code: "L",
          name: "Basic",
          price: "149",
          branchNote: "Additional branch: SAR 99/month",
          features: [
            "Support for all seven delivery apps",
            "Dashboard and operations",
            "Submit campaign requests and track their status",
            "Submit menu changes and track their status",
            "Branch data management",
            "Payments and monthly reports",
            "Data and documents",
            "Performance analysis and item sales",
            "Alerts",
          ],
        },
        {
          code: "U",
          name: "Advanced",
          price: "299",
          branchNote: "Additional branch: SAR 249/month",
          featured: true,
          features: [
            "All Basic plan features",
            "Weekly sales reports",
            "View and track compensation",
            "Order documentation with photos",
            "Submit disputes through the platform",
            "Manage and track disputes through the platform",
          ],
        },
        {
          code: "D",
          name: "Comprehensive",
          price: "499",
          branchNote: "Additional branch: SAR 399/month",
          features: [
            "All Advanced plan features",
            "Dispute submission and follow-up handled by LUD",
            "Verify campaign request implementation",
            "Verify menu change implementation",
            "Technical support",
          ],
        },
      ],
    },
    footer: {
      nav: [
        { key: "solutions", label: "LUD Solutions", to: "/solutions" },
        { key: "plans", label: "Plans", to: "/pricing" },
        { key: "contact", label: "Contact us", to: "/contactus" },
        { key: "blog", label: "Blog" },
        { key: "careers", label: "Join us / Careers" },
      ],
      legal: [
        { key: "terms", label: "Terms & Conditions", to: "/terms" },
        { key: "privacy", label: "Privacy Policy", to: "/privacy" },
        { key: "usagePolicy", label: "Usage Policy" },
        { key: "refund", label: "Cancellation & Refund", to: "/refund" },
        { key: "sla", label: "Service Level Agreement" },
        { key: "feedback", label: "Complaints & Suggestions", to: "/feedback" },
      ],
      copyright: "All rights reserved",
    },
    whatsapp: "Chat with us on WhatsApp",
  },
};

export default landingContent;
